<template>
  <div
    class="relative flex flex-col portrait:w-full justify-center items-center overflow-hidden no-scrollbar landscape:pt-8 landscape:pb-8 h-screen"
  >
    <div
      class="bg-white/40 relative p-5 portrait:pt-8 landscape:rounded-lg portrait:top-0 portrait:h-screen w-full landscape:max-w-[1240px] h-auto z-[1]"
    >
      <router-view v-slot="{ Component }">
        <transition name="slide-fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </div>
  </div>
</template>

<style scoped>
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition:
    transform 0.5s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.5s ease-in-out;
}
.slide-fade-enter,
.slide-fade-leave-to /* .slide-fade-leave-active in <2.1.8 */ {
  opacity: 0;
  transform: translateX(20px);
}

.no-scrollbar::-webkit-scrollbar {
  display: none;
}
.no-scrollbar {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
</style>
